// import Cookies from "js-cookie";

const getters = {
  userInfo: () => {
    if (process.env.NODE_ENV == "development") {
      return {
        clinicConfigId: 20,
        clinicAgentId: 253,
        txtRealName: "安安",
        txtMobile: "13894379193 17695912203 15230302025",
        txt_login_pwd: "lx13894379193 lx17695912203"
      }
    } else {
      let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      return userInfo;
    }
  },
  // 生成随机字符串
  UUID() { return 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[x]/g, function () { return (Math.random() * 16 | 0).toString(16); }); },
};

export default getters;